module.exports = {"social-media-editor":{"dropTargets":["in-social-media"]},"new-form-field":{"dropTargets":["in-form-preview"]},"preview-form-field":{"dropTargets":["in-form-preview"]},"in-bubble-item":{"dropTargets":["in-bubble-list"]}}


//////////////////
// WEBPACK FOOTER
// ./src/directives/dragula-config.json
// module id = 1wjf
// module chunks = 0